<template>
  <section id="yet" class="pb-xl-2 mb-4">
    <h2 class="subtitle h4 bg-c02 text-white rounded-top-1 p-2 px-3">
      <i class="fa fa-check" aria-hidden="true"></i><span>日時未設定</span>
    </h2>
    <div class="bg-white rounded-bottom-1 p-3 p-sm-4 py-2 py-sm-3">
      <!-- schedule Legend -->
      <ScheduleLegend></ScheduleLegend>
      <!-- ./schedule Legend -->

      <div class="table-responsive scrollbar pb-3">
        <table class="table table-bordered h-100">
          <ColGroupByMobile v-if="isMobile"></ColGroupByMobile>
          <ColGroupByPc v-else></ColGroupByPc>
          <TableHead :is-mobile="isMobile"></TableHead>
          <tbody class="border-1 fs-small lh-md">
            <tr
              v-for="(unset, key) in schedules.unset"
              :key="key"
              :class="unset.statusClass.trClass"
            >
              <TableData :schedule="unset" :is-mobile="isMobile"></TableData>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.table-responsive -->
    </div>
    <!-- /.bg -->
  </section>
</template>

<script lang="ts">
/* Import Vue */
import { defineComponent } from "vue";
/* Import components */
import ScheduleLegend from "../../../components/legend/legend.vue"; // 凡例
import ColGroupByPc from "./parts/tableColGroupByPc.vue";
import ColGroupByMobile from "./parts/tableColGroupByMobile.vue";
import TableHead from "./parts/tableHead.vue";
import TableData from "./parts/tableData.vue";
/* Import Variables */
import { schedules } from "../../../compositions/variables"; // DatabaseLists

export default defineComponent({
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  components: {
    ScheduleLegend,
    ColGroupByPc,
    ColGroupByMobile,
    TableHead,
    TableData,
  },
  setup(props: { isMobile: Boolean }) {
    const isMobile = props.isMobile;
    return {
      /* valiables */
      schedules,
      isMobile,
    };
  },
});
</script>
